var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgILetter = function SvgILetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 36 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 136H15.859C5.933 136 .964 131.037.964 121.12V0h19.523c9.927 0 14.895 4.963 14.895 14.88z"
  })));
};
export default SvgILetter;